import React, { useState } from 'react'
import { Menu, MenuItem, MenuList, Paper } from '@mui/material'
import { MoreButton } from 'common/Button/MoreButton'
import TextColorFontBody from 'common/Typography/TextColorFontBody'
import circlesOrbitColorPalette from 'common/ui/circlesColorTheme'

import PaymentStatusEditDialog from './PaymentStatusEditDialog'

const ActionMenu = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const [paymentStatusDialog, setPaymentStatusDialogOpen] = useState(false)

  const handlePaymentStatusDialogOpen = () => {
    setPaymentStatusDialogOpen(true)
  }

  const handlePaymentStatusDialogClose = () => {
    setPaymentStatusDialogOpen(false)
  }

  return (
    <>
      <MoreButton onClick={handleMenuOpen} />
      <Paper>
        <MenuList dense>
          <Menu
            id='action-menu'
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button'
            }}
          >
            <MenuItem onClick={() => handlePaymentStatusDialogOpen()}>
              <TextColorFontBody
                sx={{
                  color: circlesOrbitColorPalette.neutrals[600],
                  fontSize: '12px'
                }}
              >
                Edit payment status/Log
              </TextColorFontBody>
            </MenuItem>
            <PaymentStatusEditDialog
              handlePaymentStatusDialogClose={handlePaymentStatusDialogClose}
              paymentStatusDialog={paymentStatusDialog}
              handleMenuClose={handleMenuClose}
            />

            <MenuItem onClick={handleMenuClose}>
              <TextColorFontBody
                sx={{
                  color: circlesOrbitColorPalette.neutrals[600],
                  fontSize: '12px'
                }}
              >
                Edit sim status
              </TextColorFontBody>
            </MenuItem>
          </Menu>
        </MenuList>
      </Paper>
    </>
  )
}

export default ActionMenu
